import React from "react"
import { useTranslation } from "react-i18next"

interface UnreadNotificationPillProps {
  count: number
  direction?: "top" | "bottom"
}

const UnreadNotificationPill: React.FC<UnreadNotificationPillProps> = ({
  count,
  direction,
}) => {
  const { t } = useTranslation()
  return (
    <div className="z-[999] inline-flex h-9 items-center justify-center rounded-full bg-base-primary px-4 py-2 text-sm font-medium leading-none text-primary-foreground dark:bg-blue-500">
      {t("app.chatList.unreadMessages", { count })}{" "}
      {direction === "top" ? "↑" : "↓"}
    </div>
  )
}

export default React.memo(UnreadNotificationPill)
